export enum AnswerTypes {
  'Same' = 1,
  'Input' = 2
}
